// You can customize the template with the help of this file

//Template config options
import enData from "../views/admin/enData"
import appLogoImageName from "@src/assets/images/logo/mainlogo.png"
 
const themeConfig = {
  app: {
    appName: `${enData.labels.brandName}`,  // justChange
    appLogoImage: require("@src/assets/images/logo/mainlogo.png").default,
    appLogoImageName,

  }, 
  layout: {
    isRTL: false,
    skin: "semi-dark", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
